import type Validator from '../../models/Validator';

const PropertyTypesValidator: Validator = class {
  static isValid(value) {
    return !!value;
  }

  static getError() {
    return null;
  }
};

export default PropertyTypesValidator;
